export const SERVICE_KEY = 'idw';
export const IDW_PROVIDER_NAME_SPACE = 'idw-provider';
export var IdwExceptionsCodes;
(function (IdwExceptionsCodes) {
    IdwExceptionsCodes["NON_IDW_ACCOUNT"] = "NON_IDW_ACCOUNT";
})(IdwExceptionsCodes || (IdwExceptionsCodes = {}));
export const RwcActionEvent = 'rwc-action-event';
//# sourceMappingURL=constants.js.map